import React, { useEffect } from 'react'
import './Contact_Success_Modal.css'
import Weighing_Lottie from '../../../animation/Weighing_Lottie/Weighing_Lottie'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Celebration_Lottie from '../../../animation/Celebration_Lottie/Celebration_Lottie'

const Contact_Success_Modal = (props) => {

    const navigate = useNavigate()

    useEffect(() => {
        setTimeout(() => {
            navigate("/")
        }, 3000);
    }, [props])



    return (
        <section className='Contact_Success_Modal'>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Contact_Success_Modal modal-holder"
            >

                <Modal.Body>
                    <div className='main_container'>

                        <div className='lottie_holder_div'>
                            <Celebration_Lottie />
                        </div>

                        <p className='title'>{props?.title}</p>
                        <p className='subtext'>{props?.subtitle}</p>

                    </div>
                </Modal.Body>
            </Modal>
        </section>
    )
}

export default Contact_Success_Modal
